export default __webpack_public_path__ + "static/media/ticket-5.27c48b22.png";